import { initVideoPlayer } from "../components/employee-grid-video";

export const fetchFilteredResults = async (
    url: string,
    container: HTMLElement,
    resultsSelector: string,
): Promise<void> => {
    return fetch(url, {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" },
    })
        .then((res) => res.text())
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newResults = doc.querySelector<HTMLElement>(resultsSelector);

            if (newResults) {
                container.innerHTML = newResults.innerHTML;

                initVideoPlayer();
            }
        })
        .catch((err) => console.error("Error fetching results:", err));
};
